import { takeLatest, put, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import {
  GET_EVENT_ATTRIBUTES_REQUEST,
  GetEventAttributesRequestAction,
} from './eventAttributes.types';
import {
  getEventAttributesSuccess,
  getEventAttributesFailure,
} from './eventAttributes.action';
import * as eventAttributesService from '../../services/eventAttributesService/eventAttributesService';

function* getEventAttributesWorker(
  action: GetEventAttributesRequestAction
): SagaIterator {
  try {
    const attributes = yield call(
      eventAttributesService.getAttributes,
      action.payload
    );
    yield put(getEventAttributesSuccess(attributes));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch event attributes';
    yield put(getEventAttributesFailure(errorMessage));
  }
}

export function* eventAttributesSaga(): SagaIterator {
  yield takeLatest(GET_EVENT_ATTRIBUTES_REQUEST, getEventAttributesWorker);
}
